import { create } from 'zustand';
import api from '../api/axios';

const useAuthStore = create((set) => ({
  user:    JSON.parse(localStorage.getItem('cm_user') || 'null'),
  token:   localStorage.getItem('cm_token') || null,
  loading: false,
  error:   null,

  login: async (mobile, password) => {
    set({ loading: true, error: null });
    try {
      const { data } = await api.post('/auth/login', { mobile, password });
      localStorage.setItem('cm_token', data.token);
      localStorage.setItem('cm_user', JSON.stringify(data.user));
      set({ user: data.user, token: data.token, loading: false });
      return data;
    } catch (err) {
      set({ loading: false, error: err.response?.data?.message || 'Login failed' });
      throw err;
    }
  },

  register: async (payload) => {
    set({ loading: true, error: null });
    try {
      const { data } = await api.post('/auth/register', payload);
      localStorage.setItem('cm_token', data.token);
      localStorage.setItem('cm_user', JSON.stringify(data.user));
      set({ user: data.user, token: data.token, loading: false });
      return data;
    } catch (err) {
      set({ loading: false, error: err.response?.data?.message || 'Registration failed' });
      throw err;
    }
  },

  logout: () => {
    localStorage.removeItem('cm_token');
    localStorage.removeItem('cm_user');
    set({ user: null, token: null });
    window.location.href = '/';
  },

  setUser: (user) => {
    localStorage.setItem('cm_user', JSON.stringify(user));
    set({ user });
  },
}));

export default useAuthStore;
